// extracted by mini-css-extract-plugin
export default {"packageItemButton":"PackageItem_packageItemButton__II8ED"};